import type { UserChangeRequestReason } from '@contracts/changeRequest/ChangeRequestContract';
import { useNavigateToCreateChangeRequest } from '@src/changeRequest/useNavigateToCreateChangeRequest';
import { MenuItem } from '@src/common/components/Menu';
import { useToast } from '@src/common/hooks/useToast';
import { ChangeRequestModal } from '@src/orders/components/orderActionsMenu/modal/ChangeRequestModal';
import type { OrderListing } from '@src/orders/domain/OrderList';
import { OrderActions } from '@src/orders/domain/OrderList';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  order: OrderListing;
};
export const ChangeRequestAction = ({ order }: Props) => {
  const { t } = useTranslation();
  const { showErrorToast } = useToast();

  const { navigateToCreateChangeRequest } = useNavigateToCreateChangeRequest({
    orderId: order.id,
  });
  const [openChangeRequestModal, setOpenChangeRequestModal] = useState(false);
  const [, setReopenModal] = useState(false);

  const handleChangeRequestClick = () => {
    setOpenChangeRequestModal(true);
  };
  return (
    order.canDo(OrderActions.CHANGE_REQUEST) && (
      <>
        <MenuItem
          key={`${order.id}-change-order`}
          onClick={handleChangeRequestClick}
        >
          {t('changeRequest.title')}
        </MenuItem>
        <ChangeRequestModal
          open={openChangeRequestModal}
          onClose={() => {
            setOpenChangeRequestModal(false);
          }}
          onSuccess={(reason: UserChangeRequestReason) => {
            setReopenModal(false);
            navigateToCreateChangeRequest({ reason });
          }}
          onError={() => {
            showErrorToast(t('changeRequest.error'));
          }}
          order={order}
        />
      </>
    )
  );
};
